<template>
  <div>
    <div class="common-page mt20 printhide ml20">
      <ul class="tab-wrap" style="border: none">
        <li :class="`tab-btn ${nowIndex == index && 'active'}`" @click="changeTab(index, tab)" v-for="(tab, index) in tabList">
          {{ tab.name }}
        </li>
      </ul>
      <!-- <div class="ml20  f18 blue cursor" >
      <i class="el-icon-back"></i> 返回
    </div> -->
      <div class="mt20" id="printm">
        <div v-show="tabList[nowIndex].id == 0 || Printing">
          <el-radio-group class="printhide" @change="changeDate" type="primary" v-model="month">
            <el-radio-button v-for="item in queryDate" :label="item"></el-radio-button>
          </el-radio-group>
          <div class="f-list flex">
            <div class="flex1 flex center" style="flex-wrap: wrap;width:100%">
              <div v-show="!showData" style="width: 90%">
                <div id="tab1" class="tab1"></div>
              </div>
              <div v-show="showData || Printing" class="flex tableBox center">
                <table class="table table-bordered mt20" id="detailtable">
                  <thead>
                    <tr>
                      <th>温度/日期</th>

                      <th v-for="item in tempList">{{ item.createTime }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width:5%">温度a</td>
                      <td v-for="item in tempList">{{ item.temperaturea }}</td>
                    </tr>
                    <tr>
                      <td>温度b</td>
                      <td v-for="item in tempList">{{ item.temperatureb }}</td>
                    </tr>
                    <tr>
                      <td>温度c</td>
                      <td v-for="item in tempList">{{ item.temperaturec }}</td>
                    </tr>
                    <tr>
                      <td>温度d</td>
                      <td v-for="item in tempList">{{ item.temperatured }}</td>
                    </tr>
                  </tbody>
                  <tr class="printhide">
                    <td :colspan="tempList.length + 1">
                      <div class="flex" style="justify-content: flex-end; width: 100%">
                        <el-button style="margin-right: 10px" type="danger" size="small" @click="resetData">关闭</el-button>
                      </div>
                    </td>
                  </tr>
                </table>

                <!-- 表格 -->
              </div>
            </div>
          </div>
        </div>
        <div v-show="tabList[nowIndex].id == 1 || Printing">
          <el-radio-group class="printhide" @change="changeDate" type="primary" v-model="month">
            <el-radio-button v-for="item in queryDate" :label="item"></el-radio-button>
          </el-radio-group>
          <div class="f-list flex">
            <div class="flex1 flex center" style="flex-wrap: wrap">
              <div v-show="!showData" style="width: 90%">
                <div id="tab2" class="tab1"></div>
              </div>
              <div v-show="showData || Printing" class="tableBox center">
                <table class="table table-bordered mt20" id="detailtable">
                  <thead>
                    <tr>
                      <th>电压/日期</th>

                      <th v-for="item in voltageList">{{ item.createTime }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width:5%">电压a</td>
                      <td v-for="item in voltageList">{{ item.voltagea }}</td>
                    </tr>
                    <tr>
                      <td>电压b</td>
                      <td v-for="item in voltageList">{{ item.voltageb }}</td>
                    </tr>
                    <tr>
                      <td>电压c</td>
                      <td v-for="item in voltageList">{{ item.voltagec }}</td>
                    </tr>
                  </tbody>
                  <tr class="printhide">
                    <td :colspan="tempList.length + 1">
                      <div class="flex" style="justify-content: flex-end; width: 100%">
                        <el-button style="margin-right: 10px" type="danger" size="small" @click="resetData">关闭</el-button>
                      </div>
                    </td>
                  </tr>
                </table>

                <!-- 表格 -->
              </div>
            </div>
          </div>
        </div>
        <div v-show="tabList[nowIndex].id == 2 || Printing">
          <el-radio-group class="printhide" @change="changeDate" type="primary" v-model="month">
            <el-radio-button v-for="item in queryDate" :label="item"></el-radio-button>
          </el-radio-group>
          <div class="f-list flex">
            <div class="flex1 flex center" style="flex-wrap: wrap">
              <div v-show="!showData" style="width: 90%">
                <div id="tab3" class="tab1"></div>
              </div>
              <div v-show="showData || Printing" class="tableBox center">
                <table class="table table-bordered mt20" id="detailtable">
                  <thead>
                    <tr>
                      <th>电流/日期</th>

                      <th v-for="item in currentList">{{ item.createTime }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width:5%">电流a</td>
                      <td v-for="item in currentList">{{ item.currenta }}</td>
                    </tr>
                    <tr>
                      <td>电流b</td>
                      <td v-for="item in currentList">{{ item.currentb }}</td>
                    </tr>
                    <tr>
                      <td>电流c</td>
                      <td v-for="item in currentList">{{ item.currentc }}</td>
                    </tr>
                  </tbody>
                  <tr class="printhide">
                    <td :colspan="currentList.length + 1">
                      <div class="flex" style="justify-content: flex-end; width: 100%">
                        <el-button style="margin-right: 10px" type="danger" size="small" @click="resetData">关闭</el-button>
                      </div>
                    </td>
                  </tr>
                </table>

                <!-- 表格 -->
              </div>
            </div>
          </div>
        </div>
        <div v-show="tabList[nowIndex].id == 3 || Printing">
          <el-radio-group class="printhide" @change="changeDate" type="primary" v-model="month">
            <el-radio-button v-for="item in queryDate" :label="item"></el-radio-button>
          </el-radio-group>
          <div class="f-list flex">
            <div class="flex1 flex center" style="flex-wrap: wrap">
              <div v-show="!showData" style="width: 90%">
                <div id="tab4" class="tab1"></div>
              </div>
              <div v-show="showData || Printing" class="tableBox center">
                <table class="table table-bordered mt20" id="detailtable">
                  <thead>
                    <tr>
                      <th style="width:5%">电流/日期</th>

                      <th v-for="item in LeakageList">{{ item.createTime }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>剩余电流</td>
                      <td v-for="item in LeakageList">
                        {{ item.currentLeakage }}
                      </td>
                    </tr>
                  </tbody>
                  <tr class="printhide">
                    <td :colspan="LeakageList.length + 1">
                      <div class="flex" style="justify-content: flex-end; width: 100%">
                        <el-button style="margin-right: 10px" type="danger" size="small" @click="resetData">关闭</el-button>
                      </div>
                    </td>
                  </tr>
                </table>

                <!-- 表格 -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="search-form ml20 flex printhide">
      <div class="block flex ml20 mt20">
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </div>
      <div class="ml10 mt20">
        <el-button type="primary" @click="searchSubmit" size="small"
          >查询</el-button
        >
      </div>
    </div> -->
    <div class="center flex">
      <el-button type="primary" @click="a">
        打印报表
      </el-button>
      <el-button type="primary" @click="$router.back()">
        返回
      </el-button>
    </div>

    <el-button v-show="false" type="primary" ref="btnp" v-print="'#printm'">打印报表 </el-button>

    <!-- <div class="center mt20 printhide" style="margin-bottom:20px">

    </div> -->
  </div>
</template>
<script>
import echarts from "echarts";
import { getTime } from "../../api/common.js";
export default {
  data() {
    return {
      power: 0,
      month: "",
      Printing: false,
      nowIndex: 0,
      value1: [], // 时间查询
      showData: false,
      tabList: [
        { name: "最高温度", id: 0, loading: false },
        { name: "最高电压", id: 1, loading: false },
        { name: "最高电流", id: 2, loading: false },
        { name: "剩余电流", id: 3, loading: false },
      ],
      params: {
        year: "",
        month: "",
        deviceId: this.$route.query.id,
      },
      queryDate: [],
      // oneData:[],
      tempList: [], // 温度
      voltageList: [], //电压
      currentList: [],
      LeakageList: [],
      fourData: [], //巡查整改情况
      twoData: [], // 巡查点位数量
      threeData: [], //巡查人员次数
    };
  },
  created() {
    // let time = data.sysTime2.replace(/-/g, "/");
    // let time = new Date(+new Date() + 8 * 3600 * 1000)
    //   .toJSON()
    //   .substr(0, 19)
    //   .replace("T", " ")
    //   .replace(/-/g, "/");

    // let timeLine = new Date(time).getTime();
    // this.params.starttime = new Date(timeLine).Format("yyyy-MM-01 00:00:00");
    // this.params.endtime = new Date(timeLine).Format("yyyy-MM-dd hh:mm:ss");
    // 当前日期
    var dataArr = [];
    var data = new Date();
    // var year = data.getFullYear();
    data.setMonth(data.getMonth() + 1); //获取到当前月份,设置月份
    for (var i = 0; i < 12; i++) {
      data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
      dataArr.push(data.getFullYear() + "-" + (data.getMonth() + 1));
    }
    this.queryDate = dataArr.reverse();
    // this.changeDate()
    this.month = this.queryDate[this.queryDate.length - 1];
    this.changeDate(this.month);
  },
  mounted() {},
  //     watch:{
  //     cpNum(){
  //          this.getList()
  //     }
  // },
  methods: {
    a() {
      this.Printing = true;
      setTimeout(() => {
        this.$refs.btnp.$el.click();
        this.Printing = false;
      }, 1000);
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.showData = false;

      this.getList();
    },
    changeDate(v) {
      console.log(v);
      this.showData = false;
      this.params.year = v.split("-")[0];
      this.params.month = v.split("-")[1];
      this.getList();
    },
    resetData() {
      this.showData = false;
    },
    getList() {
      this.getWater();
    },

    searchSubmit() {
      // function changeArr(val) {
      //   var arr = val.split(" ");
      //   var n = arr[0].replace(/['年','月']/g, "-");
      //   n = n.replace(/日/g, "");
      //   return n;
      // }
      this.clear();
      this.params.starttime = this.value1[0];
      this.params.endtime = this.value1[1];
      // console.log(this.params)
      // return
      //  console.log(this.params)
      this.getList();
    },
    clear() {
      (this.fourData = []), //巡查整改情况
        (this.twoData = []), // 巡查点位数量
        (this.threeData = []); //巡查人员次数
    },

    async getWater() {
      var arr2 = [];
      var arr1 = [];
      var arr3 = [];
      var arr4 = [];
      var arr5 = [];

      var _this = this;
      //巡查区域
      // await this.$post("/patrol/selectarea").then((data) => {
      //   data.data.map((item) => {
      //     areaList.push(item.x_company_area);
      //   });
      // });
      //巡查人员
      // await this.$post('/patrol/xcpersonlist')

      if (this.tabList[this.nowIndex].id === 0 || this.Printing) {
        await this.$get("/report/reportAppliance/temperatureaList", this.params).then((res) => {
          if (res) {
            //处理巡查整改情况
            this.tempList = res.rows;

            this.tempList.map((item) => {
              arr2.push(item.createTime);
              arr1.push(item.temperaturea);
              arr3.push(item.temperatureb);
              arr4.push(item.temperaturec);
              arr5.push(item.temperatured);

              // arr2.push(item.createTime)
            });
            this.makeLine("tab1", {
              title: {
                text: `${this.month}最高温度统计表`,
                left: "8%",
              },
              legend: {
                top: "0px",
                right: "0px",
                left: "center",
                data: ["温度A", "温度B", "温度C", "温度D"],
              },
              xAxis: {
                data: arr2,
                name: "",
                nameTextStyle: {
                  fontSize: 14,
                  fontFamily: "Arial",
                  fontWeight: "bold",
                },
              },
              series: [
                {
                  name: "温度A",
                  type: "line",
                  data: arr1,

                  large: true,
                },
                {
                  name: "温度B",
                  type: "line",
                  data: arr3,

                  large: true,
                },
                {
                  name: "温度C",
                  type: "line",
                  data: arr4,

                  large: true,
                },
                {
                  name: "温度D",
                  type: "line",
                  data: arr5,

                  large: true,
                },
              ],
            });
          }
          // 巡查点占比
        });
      }
      if (this.tabList[this.nowIndex].id === 1 || this.Printing) {
        await this.$get("/report/reportAppliance/voltageList", this.params).then((res) => {
          if (res) {
            //处理巡查整改情况
            this.voltageList = res.rows;

            this.voltageList.map((item) => {
              arr2.push(item.createTime);
              arr1.push(item.voltagea);
              arr3.push(item.voltageb);
              arr4.push(item.voltagec);

              // arr2.push(item.createTime)
            });
            this.makeLine("tab2", {
              title: {
                text: `${this.month}最高电压统计表`,
                left: "8%",
              },
              legend: {
                top: "0px",
                right: "0px",
                left: "center",
                data: ["电压A", "电压B", "电压C", "电压D"],
              },
              xAxis: {
                data: arr2,
                name: "",
                nameTextStyle: {
                  fontSize: 14,
                  fontFamily: "Arial",
                  fontWeight: "bold",
                },
              },
              yAxis: {
                splitLine: {
                  show: true,
                },
                splitArea: {
                  show: false,
                },
              },
              series: [
                {
                  name: "电压A",
                  type: "bar",
                  data: arr1,
                  itemStyle: {
                    color: "#88B6BF",
                  },
                  large: true,
                },
                {
                  name: "电压B",
                  type: "bar",
                  data: arr3,
                  itemStyle: {
                    color: "#6599A5",
                  },
                  large: true,
                },
                {
                  name: "电压C",
                  type: "bar",
                  data: arr4,
                  itemStyle: {
                    color: "#92C2CC",
                  },
                  large: true,
                },
              ],
            });
          }
          // 巡查点占比
        });
      }
      if (this.tabList[this.nowIndex].id === 2 || this.Printing) {
        await this.$get("/report/reportAppliance/currentList", this.params).then((res) => {
          if (res) {
            //处理巡查整改情况
            this.currentList = res.rows;

            this.currentList.map((item) => {
              arr2.push(item.createTime);
              arr1.push(item.currenta);
              arr3.push(item.currentb);
              arr4.push(item.currentc);

              // arr2.push(item.createTime)
            });
            this.makeLine("tab3", {
              title: {
                text: `${this.month}最高电流统计表`,
                left: "8%",
              },
              legend: {
                top: "0px",
                right: "0px",
                left: "center",
                data: ["电流A", "电流B", "电流C", "电流D"],
              },
              xAxis: {
                data: arr2,
                name: "",
                nameTextStyle: {
                  fontSize: 14,
                  fontFamily: "Arial",
                  fontWeight: "bold",
                },
              },
              yAxis: {
                splitLine: {
                  show: true,
                },
                splitArea: {
                  show: false,
                },
                name: "",
                nameTextStyle: {
                  fontSize: 14,
                  fontFamily: "Arial",
                  fontWeight: "bold",
                },
                //  max: 10000,
                // scale: false,
                // splitNumber: 10,
                // minInterval: 0
              },
              series: [
                {
                  name: "电流A",
                  type: "bar",
                  stack: "最高电流",
                  itemStyle: {
                    color: "#83B95C",
                  },
                  data: arr1,

                  large: true,
                },
                {
                  name: "电流B",
                  type: "bar",
                  data: arr3,
                  stack: "最高电流",
                  itemStyle: {
                    color: "#6088CC",
                  },
                  large: true,
                },
                {
                  name: "电流C",
                  type: "bar",
                  data: arr4,
                  stack: "最高电流",
                  itemStyle: {
                    color: "#F8C435",
                  },
                  large: true,
                },
              ],
            });
          }
          // 巡查点占比
        });
      }
      if (this.tabList[this.nowIndex].id === 3 || this.Printing) {
        await this.$get("/report/reportAppliance/currentLeakageList", this.params).then((res) => {
          if (res) {
            //处理巡查整改情况
            this.LeakageList = res.rows;

            this.LeakageList.map((item) => {
              arr2.push(item.createTime);
              arr1.push(item.currentLeakage);

              // arr2.push(item.createTime)
            });
            this.makeLine("tab4", {
              title: {
                text: `${this.month}剩余电流统计表`,
                left: "8%",
              },
              xAxis: {
                data: arr2,
                name: "",
                nameTextStyle: {
                  fontSize: 14,
                  fontFamily: "Arial",
                  fontWeight: "bold",
                },
              },

              yAxis: {
                splitLine: {
                  show: true,
                },
                splitArea: {
                  show: true,
                  areaStyle: {
                    color: "#404040",
                  },
                },
                name: "",
                nameTextStyle: {
                  fontSize: 14,
                  fontFamily: "Arial",
                  fontWeight: "bold",
                },
                //  max: 10000,
                // scale: false,
                // splitNumber: 10,
                // minInterval: 0
              },
              series: [
                {
                  name: "",
                  type: "line",
                  stack: "最高电流",
                  areaStyle: {
                    color: "#C65B12",
                  },
                  lineStyle: {
                    color: "#ECCCB7",
                  },
                  data: arr1,
                  large: true,
                },
              ],
            });
          }
          // 巡查点占比
        });
      }
      // this.makeChart(this.threeData, "tab3", "行业类型单位比例");
      // this.makeLine(this.twoData, "tab2", {
      //   title: "接警数量月统计",
      //   hname: "月份",
      //   sname: "数量",
      //   insername: "数量",
      // });
      // this.makeLine(this.fourData, "tab4", {
      //   title: "接警数量地区统计",
      //   hname: "地区",
      //   sname: "数量",
      //   insername: "地区数量",
      // });
    },

    makeLine(id, config) {
      // arr1.map((item) => {
      //   arr2.push(item.createTime);
      //   arrdata.push(item)
      // });
      echarts.init(document.getElementById(id)).dispose();
      var _this = this;
      var option = {
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: true,
          orient: "vertical",
          top: "30px",
          feature: {
            myTool1: {
              show: true,
              title: "查看数据",
              icon:
                "path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891",
              onclick: function() {
                _this.showData = true;
              },
            },
            dataZoom: {
              show: false,
              yAxisIndex: "none",
            },
            dataView: {
              show: false,
            },
            magicType: { type: ["line", "bar"] },
            restore: { show: false },
            saveAsImage: {},
          },
        },
        //  legend: {
        //     data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
        // },
        xAxis: {
          data: [],
          name: "",
          nameTextStyle: {
            fontSize: 14,
            fontFamily: "Arial",
            fontWeight: "bold",
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          splitArea: {
            show: false,
          },
          name: "",
          nameTextStyle: {
            fontSize: 14,
            fontFamily: "Arial",
            fontWeight: "bold",
          },
          //  max: 10000,
          // scale: false,
          // splitNumber: 10,
          // minInterval: 0
        },
        dataZoom: [
          {
            start: 2,
            type: "inside",
          },
          {
            type: "slider",
            start: 2,
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            data: [],
            // label: {
            //   show: true,
            //   position: "top",
            //   fontSize: 18,

            //   color: "#000",
            // },
            large: true,
          },
          {
            name: "",
            type: "line",
            data: [],
            // label: {
            //   show: true,
            //   position: "top",
            //   fontSize: 18,

            //   color: "#000",
            // },
            large: true,
          },
          {
            name: "",
            type: "line",
            data: [],
            // label: {
            //   show: true,
            //   position: "top",
            //   fontSize: 18,

            //   color: "#000",
            // },
            large: true,
          },
          {
            name: "",
            type: "line",
            data: [],
            // label: {
            //   show: true,
            //   position: "top",
            //   fontSize: 18,

            //   color: "#000",
            // },
            large: true,
          },
        ],
      };
      var setopt = { ...option, ...config };
      console.log(setopt);
      console.log(id);

      echarts.init(document.getElementById(id)).setOption(setopt);
    },
    //饼图
    makeChart(arr, id, title) {
      // console.log(this.chartList)
      var arr2 = [];
      if (arr.length == 0) {
        arr.push({ value: 0, name: "暂无数据" });
      }
      arr = arr.filter((item) => {
        if (item.value > 0) {
          arr2.push(item);
        }
        return item.value > 0;
      });

      let option = {
        title: {
          text: title,
          left: "center",
          top: "370px",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "100px",
          data: arr2,
        },
        series: [
          {
            name: "",
            title: "访问来源",
            show: true,
            type: "pie",
            //            label: {
            //   show: true,
            //    position: 'top',
            //    fontSize: 18,

            //    color:'#000'
            // },
            radius: "70%",
            center: ["50%", "50%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      echarts.init(document.getElementById(id)).setOption(option);
    },
  },
};
</script>
<style scoped lang="scss">
.tableBox {
  width: 90%;

  font-size: 13px;
}
.table-bordered {
  border: 1px solid #dddddd;
}
.table {
  width: 90%;
}
// #tab1 {
//   width: 550px;
//   height: 450px;
// }
.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  padding: 3px;
  vertical-align: center;
  text-align: center;
  border-top: 1px solid #fff;
  background: #ecf2f4;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #fff;
}
.tab1 {
  width: 100%;
  min-height: 400px;
  margin: 20px 80px 20px 0px;
}

#line {
  height: 250px;
  width: 100%;
}

@media print {
  #tab1,
  #tab2,
  #tab3,
  #tab4 {
  }
  .printhide {
    display: none;
  }
  #printm {
  }
}
</style>
